import { createGlobalStyle } from 'styled-components';

const PaletteStyles = createGlobalStyle`
  :root {
    --wonyous: #27AAE1;
    --american-river: #636E72;
    --midnight-blue: #2C3E50;
    --lynx-white: #F5F6FA;
    --dracula-orchid: #2D3436;
    --faded-poster: #81ECEC;
  }
`;

export default PaletteStyles;